import React, { useContext, useEffect, useState } from "react";

import { InvoiceService } from "../services/invoice.service";
import { useSuppliersContext } from "domain/Supplier/context";

const InvoicesContext = React.createContext({});

export function useInvoicesContext() {
  return useContext(InvoicesContext);
}

export function InvoicesProvider({ children }) {
  const [invoices, setInvoices] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const { suppliers } = useSuppliersContext();

  const handleInvoicesSearch = (value) => {
    // ovde je bio event pa smo staviliu da bude value
    setSearchTerm(value);
  };

  useEffect(() => {
    let isActive = true;
    InvoiceService.get({ searchTerm: searchTerm }).then((invoices) => {
      if (!isActive) return;
      const invoicesWithSuppliers = invoices.map((invoice) => ({
        ...invoice,
        supplier: suppliers.find((supplier) => supplier.id === invoice.supplierId),
      }));
      setInvoices(invoicesWithSuppliers);
    });
    return () => {
      isActive = false;
    };
  }, [searchTerm, suppliers]);

  return (
    <InvoicesContext.Provider
      value={{
        invoices,
        handleInvoicesSearch,
      }}
    >
      {children}
    </InvoicesContext.Provider>
  );
}
